<template>
    <div class="container-fluid w-100 pb-3" style="overflow: hidden">
      <navbar :title="$t('menu.license_report')"/>
      <div class="search-form my-2 px-2">
      <div class="col-sm-12 search-form-title">
        <font-awesome-icon icon="search" />
        {{ $t('common.search') }}
      </div>
      <form @submit.prevent="onSubmit">
        <div class="row mb-4">
          <div class="col-sm-4">
              <span class="span-title">
                {{ $t('trip_list.road_sec_from') }}
              </span>
              <input
                  id="end"
                  v-model="dateFrom"
                  type="date"
                  class="form-control form-control-sm"
                  :placeholder="returnCurrentDate"
              />
          </div>
          <div class="col-sm-4">
              <span class="span-title">
                {{ $t('trip_list.road_sec_to') }}
              </span>
              <input
                  id="end"
                  v-model="dateTo"
                  type="date"
                  class="form-control form-control-sm"
                  :placeholder="returnEndOfMonth"
              />
          </div>
          <div class="col-sm-4">
            <span class="span-title">{{ $t('companies.name') }}</span>
            <input class="form-control form-control-sm" type="text" v-model="companyName"/>
          </div>
        </div>
        <div class="col-12 d-flex justify-content-end">
          <button type="submit" class="btn btn-primary form-button">
            {{ $t('common.search') }}
          </button>
        </div>
      </form>
    </div>
      <div  v-if="allActiveLicenseUsers.length > 0 && searchResultsDone" class="col-sm-12 list-content nopads">
        <table class="table table-sm">
          <tbody>
            <tr>
              <td class="item-detail-text strong">
                {{ $t('license_report.active_license_users') }} ({{ selectedMonth }}/{{ selectedYear }})
              </td>
              <td class="item-detail-text">
                {{ allActiveLicenseUsers.length }}
              </td>
            </tr>
            <tr>
              <td class="item-detail-text">
                {{ $t('license_report.total_users') }}.
              </td>
              <td class="item-detail-text">
                {{ totalUsers }} ({{ totalUsage }})
              </td>
            </tr>
            <tr>
              <td class="item-detail-text">
                {{ $t('license_report.total_roles') }}
              </td>
              <td class="item-detail-text">
                {{ totalRoles }}
              </td>
            </tr>
            <tr>
              <td class="item-detail-text">
                {{ $t('license_report.total_superusers') }}
              </td>
              <td class="item-detail-text">
                {{ totalSuperUsers }}
              </td>
            </tr>
            <tr>
              <td class="item-detail-text">
                {{ $t('license_report.total_billed_roles') }}
              </td>
              <td class="item-detail-text">
                {{ totalBilledRoles }} ({{ $t('license_report.observers') }}: {{ totalBilledObservers }}, {{ $t('license_report.workers') }}: {{ totalBilledWorkers }})
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="allActiveLicenseUsers.length > 0 && searchResultsDone" class="col-12 d-flex justify-content-end my-2">
        <button class="btn btn-outline-success form-button" :disabled="results.length === 0" @click="downloadLicenseReportExcel">
          {{ $t('common.download_excel') }}
        </button>
      </div>
    <Transition name="fade">
      <license-summary-table
        :results="results"
        :allusers="users"
        :date-from="dateFromNum"
        :date-to="dateToNum"
      />
    </Transition>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>
<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'
import {userHelper} from '../mixins/UserMixin'
import {downloadHelper} from '../mixins/DownloadMixin'
import LicenseSummaryTable from './LicenseSummaryTable'
import Navbar from "@/components/utils/Navbar";
import {inject} from "vue";

export default {
    name: 'LicenseAdminView',
    components: {Navbar, LicenseSummaryTable},
    mixins: [restApi, timeUtils, userHelper, downloadHelper],
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            results: [],
            allActiveLicenseUsers: [],
            selectedMonth: null,
            selectedYear: null,
            company: null,
            editMode: false,
            loading: false,
            dateFrom: null,
            searchTimeStart: null,
            searchTimeEnd: null,
            searchResultsDone: false,
            test: null,
            users: [],
            dateTo: null,
            totalUsers: 0,
            totalUsage: 0,
            totalRoles: 0,
            totalSuperUsers: 0,
            totalBilledObservers: 0,
            totalBilledWorkers: 0,
            totalBilledRoles: 0,
            searchExists: false,
            searchParamsSave: null,
            companyName: ""
        }
    },
    computed: {
        returnCurrentDate() {
            return new Date(this.getMonthStart()).toDateString()

        },
        returnEndOfMonth() {
            let today = new Date()
            return new Date(today.getFullYear(), today.getMonth()+1, 0).toDateString()
        },
        dateFromNum() {
            return new Date(this.dateFrom).getTime()+5*60*60*1000
        },
        dateToNum() {
            return new Date(this.dateTo).getTime()+5*60*60*1000
        },
    },
    mounted() {
        this.dateFrom = new Date(this.returnCurrentDate)
        this.dateTo = new Date(this.returnEndOfMonth)
    },
    methods: {
        onSubmit: function (){
            this.results = []
            if (this.dateFromNum < this.dateToNum) {
                this.searchResultsDone = false
                this.totalUsers = 0
                this.totalUsage = 0
                this.totalRoles = 0
                this.totalSuperUsers = 0
                this.totalBilledRoles = 0
                this.totalBilledWorkers = 0
                this.totalBilledObservers = 0
                this.fetchCompanies()
                this.fetchActiveLicenses()
            }
            else{
                this.showAlert(this.$t('license_report.search_error'))
            }

        },
        fetchCompanies: function () {
            let params = {}
            params.dateStart= this.dateFromNum
            params.dateEnd = this.dateToNum
            params.companyName = this.companyName
            this.searchParamsSave = params
            this.searchExists = true
            this.loading = true
            this.restFetchParams(this.usersAndCompaniesURL, params, this.handleAllUsersAndCompanies)
        },
        handleAllUsersAndCompanies: function (response) {
            this.searchResultsDone = true
            this.testresult = response.data
            this.totalUsers = this.testresult[this.testresult.length-1].total_users
            this.totalUsage = this.testresult[this.testresult.length-1].supervisors_usage + this.testresult[this.testresult.length-1].workers_usage
            this.totalRoles = this.testresult[this.testresult.length-1].total_roles
            this.totalBilledRoles = this.testresult[this.testresult.length-1].total_billed_roles
            this.totalBilledObservers = this.testresult[this.testresult.length-1].total_billed_observers
            this.totalBilledWorkers = this.testresult[this.testresult.length-1].total_billed_workers
            this.totalSuperUsers = this.testresult[this.testresult.length-1].total_superusers
            this.loading = false
            this.results = this.testresult.slice(0, this.testresult.length-1)
        },
        async fetchActiveLicenses() {
            this.allActiveLicenseUsers = (await this.fetchAllLicenseReportUsers(this.dateFrom)).data;
            this.selectedMonth = new Date(this.dateFrom).getMonth() + 1;
            this.selectedYear = new Date(this.dateFrom).getFullYear();
        },
        downloadLicenseReportExcel: function () {
            this.loading = true
            this.restGetDownloadFile(this.usersAndCompaniesURL + '/Excel',
                this.getCommonReportParams( this.searchParamsSave),
                this.downloadSuccess,
                this.downloadFail)
        },
        downloadSuccess: function (response) {
            this.loading = false
            this.downloadFile(response, this.$t('license_report.license_report_file_name'))
        },
        downloadFail: function () {
            this.loading = false
            this.showAlert(this.$t('common.report_generation_failed'))
        }
    }
}
</script>
